import { makeMultiSearch, makeSearch } from "../../UI/Search/Search";
import HighSchoolTranscriptStatusService from "../../../Services/HighSchoolTranscriptStatus.service";
import HighSchoolTranscriptStatusLookupModal from "./HighSchoolTranscriptStatusLookupModal";
const makeSearchArgs = {
    loadOptions: (search, options) => HighSchoolTranscriptStatusService.search({
        ids: options === null || options === void 0 ? void 0 : options.ids,
        query: search || (options === null || options === void 0 ? void 0 : options.query),
        names: options === null || options === void 0 ? void 0 : options.names,
        srcSystemIds: options === null || options === void 0 ? void 0 : options.srcSystemIds,
    }, { max: 20 }).then(({ data }) => data),
    label: "name",
    value: "id",
};
export const HighSchoolTranscriptStatusSearch = makeSearch(makeSearchArgs);
export const HighSchoolTranscriptStatusMultiSearch = makeMultiSearch(Object.assign(Object.assign({}, makeSearchArgs), { 
    // @ts-expect-error - TS2322 - Type 'ComponentType<WithModalParams<LookupModalProps<HighSchoolTranscriptStatus, any>>>' is not assignable to type 'ComponentType<never> | undefined'.
    lookupModal: HighSchoolTranscriptStatusLookupModal }));
